module.exports = __webpack_public_path__ + "img/ads_nophoto_motorcycle.8ab19e29.png";